import moment from "moment";
import { useEffect, useState } from "react";

import { MonitorTableAnalysisItem } from "../../types/analysis";
import { getPagination } from "../../utils/pagination";

import styles from "./monitor-summary-table.module.css";

type MonitorSummaryTableProps = {
  tableData?: MonitorTableAnalysisItem[];
};

export const MonitorSummaryTable = ({
  tableData,
}: MonitorSummaryTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 12;

  const paginatedData = tableData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const totalPages = Math.ceil((tableData?.length || 0) / rowsPerPage);
  const pages = getPagination(currentPage, totalPages);

  useEffect(() => {
    setCurrentPage(1);
  }, [tableData]);

  return (
    <div className={styles.tableSection}>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th rowSpan={2}>Datum</th>
            <th rowSpan={2}>Kundenbesuche</th>

            <th colSpan={2}>Befall</th>
            <th colSpan={2}>Kein Befall</th>
            <th colSpan={2}>Nicht erreichbar</th>

            <th rowSpan={2}>Monitore geprüft</th>
            <th rowSpan={2}>Nicht kontrolliert</th>
            <th rowSpan={2}>Monitore gesamt</th>
          </tr>

          <tr>
            <th>#</th>
            <th>%</th>

            <th>#</th>
            <th>%</th>

            <th>#</th>
            <th>%</th>
          </tr>
        </thead>

        <tbody>
          {paginatedData?.map((row, index) => (
            <tr key={index}>
              <td>{moment(row.date).format("DD.MM.YY")}</td>
              <td>
                {row.type === "monitoring"
                  ? "Monitoring"
                  : row.type === "auftrag"
                    ? "Bekämpfung"
                    : row.type}
              </td>

              <td>{row.infestation.count}</td>
              <td
                style={{
                  color: "#3D5170",
                  fontWeight: "500",
                }}
              >
                {row.infestation.percentage}%
              </td>

              <td>{row.noInfestation.count}</td>
              <td
                style={{
                  color: "#3D5170",
                  fontWeight: "500",
                }}
              >
                {row.noInfestation.percentage}%
              </td>

              <td>{row.unreachable.count}</td>
              <td
                style={{
                  color: "#3D5170",
                  fontWeight: "500",
                }}
              >
                {row.unreachable.percentage}%
              </td>

              <td>{row.monitorsChecked}</td>
              <td>{row.monitorsNotChecked}</td>
              <td>{row.monitorsTotal}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={styles.pagination}>
        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
          &laquo;
        </button>

        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
        >
          &lt;
        </button>

        {pages.map((page, idx) =>
          page === "..." ? (
            <span key={idx} className={styles.dots}>
              ...
            </span>
          ) : (
            <button
              key={idx}
              onClick={() => setCurrentPage(page)}
              className={page === currentPage ? styles.active : ""}
            >
              {page}
            </button>
          )
        )}

        <button
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          &gt;
        </button>

        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
        >
          &raquo;
        </button>
      </div>
    </div>
  );
};
